import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { APP_NAME } from '../../constants/brand'
import { createDebug } from '../../utils/debugLog'

const log = createDebug('dw:header-unification')

/**
 * Shared brand mark (logo + wordmark) — the single source of truth for the global
 * header identity across the marketing landing (NavbarV2) and the authenticated app
 * (layout/Header). Canonical brand = the landing look: the crescent logo asset plus
 * the Fustat wordmark. See RFC / Workplace post 1562612608829370.
 *
 * The markup below reproduces the landing NavbarV2 brand link exactly so that the
 * landing (and its static mirror, ConsentBackdrop.tsx) stays pixel-identical.
 */
export default function BrandMark({
  to = '/',
  onClick,
  surface,
  className = '',
}: {
  to?: string
  onClick?: () => void
  /** Which surface renders this mark; recorded for the header-unification trace. */
  surface: 'app' | 'landing'
  className?: string
}) {
  useEffect(() => {
    log('brandmark-mount surface=%s', surface)
  }, [surface])

  return (
    <Link
      to={to}
      onClick={onClick}
      className={`flex min-w-0 items-center gap-2 no-underline transition-opacity hover:opacity-80 md:gap-3 ${className}`}
    >
      <img
        src="/landing-v2/logo-icon.png"
        alt={APP_NAME}
        className="w-[22px] h-[22px] object-contain"
      />
      <span className="truncate font-[Fustat] text-lg font-semibold leading-none text-white opacity-[0.92] md:text-2xl">
        {APP_NAME}
      </span>
    </Link>
  )
}
